import { render, staticRenderFns } from "./TableLicenses.vue?vue&type=template&id=0ff2861e&"
import script from "./TableLicenses.vue?vue&type=script&lang=js&"
export * from "./TableLicenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports